module.exports = __webpack_public_path__ + "zmenseni-prsou_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_4_after.jpg
// module id = 1283
// module chunks = 0